import { BaseDialog } from "./dialog"
import { useState } from "react"
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "react-query";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Label } from "../ui/label";
import { toast } from "../ui/use-toast";
import { setOneTimeContractAdditionalFee } from "@/service/weexpertService";
import { Loader2 } from "lucide-react";

export default function AdditionalFeePopup({ contractId, onSuccess }) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);
  const [feeAmount, setFeeAmount] = useState("");
  const [feeComment, setFeeComment] = useState("");

  const mutation = useMutation({
    mutationFn: (data) => setOneTimeContractAdditionalFee(contractId, data),
    onSuccess: () => {
      toast({
        title: "Sukces",
        description: "Dodatkowa opłata została zapisana",
      });
      setOpen(false);
      setFeeAmount("");
      setFeeComment("");
      if (onSuccess) {
        onSuccess();
      }
      queryClient.invalidateQueries(['oneTimeContract', contractId]);
    },
    onError: (error) => {
      toast({
        title: "Błąd",
        description: error.response?.data?.message || "Nie udało się zapisać dodatkowej opłaty",
        variant: "destructive",
      });
    }
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const data = {
      feeAmount: feeAmount === "" ? null : parseFloat(feeAmount),
      feeComment: feeComment === "" ? null : feeComment
    };
    
    mutation.mutate(data);
  };

  const handleCancel = () => {
    setOpen(false);
    setFeeAmount("");
    setFeeComment("");
  };

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      buttonText="Ustaw dodatkową opłatę"
      dialogTitle="Ustaw dodatkową opłatę"
      className="bg-blue-600 text-white hover:bg-blue-700"
      ommitStyles={true}
    >
      <form onSubmit={handleSubmit} className="mt-4 space-y-4">
        <div className="space-y-2">
          <Label htmlFor="feeAmount">Kwota opłaty (PLN)</Label>
          <Input
            id="feeAmount"
            type="number"
            step="0.01"
            min="0"
            value={feeAmount}
            onChange={(e) => setFeeAmount(e.target.value)}
            placeholder="Pozostaw puste aby usunąć"
            disabled={mutation.isLoading}
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="feeComment">Opis opłaty</Label>
          <Textarea
            id="feeComment"
            value={feeComment}
            onChange={(e) => setFeeComment(e.target.value)}
            placeholder="Opcjonalny opis dodatkowej opłaty"
            rows={3}
            disabled={mutation.isLoading}
          />
        </div>
        
        <div className="flex justify-end space-x-2 pt-4">
          <Button
            type="button"
            variant="outline"
            onClick={handleCancel}
            disabled={mutation.isLoading}
          >
            Anuluj
          </Button>
          <Button
            type="submit"
            disabled={mutation.isLoading}
            className="bg-blue-600 hover:bg-blue-700"
          >
            {mutation.isLoading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Zapisywanie...
              </>
            ) : (
              'Zapisz'
            )}
          </Button>
        </div>
      </form>
    </BaseDialog>
  )
}